import { httpReducer, reduceReducers } from "../lib/create-action";
import { combineReducers } from "redux";
import missingAlbumArt from "../images/missing.png";
import {
  fetchCategoryActionName,
  fetchDirectoryCategoryActionName,
  browseSearchShowActionName,
  browseSearchDirectoryShowActionName,
  clearShowsActionName,
  getCategoriesActionName,
} from "../action_managers/show_search";
import identity from "lodash/identity";

const initialState = {
  categoryShows: {
    loadingCount: 0,
  },
  categoryDirectoryShows: {
    loadingCount: 0,
  },
  search: { latestRequestID: "", results: [] },
  searchDirectoryShows: { latestRequestID: "", results: [] },
  activeAdCategories: { categories: [] },
};

const directoryShowMapper = resp => {
  return resp.map(directoryShow => ({
    ...directoryShow,
    title: directoryShow.collectionName,
    isDirectoryShow: true,
    imageURL: directoryShow.imageURL || missingAlbumArt,
  }));
};

const categoryReducers = (mapper = identity) => {
  return {
    started: (state, action) => ({
      ...state,
      loadingCount: state.loadingCount + 1,
    }),
    success: (state, action) => ({
      ...state,
      [action.data.rootCategoryUUID]: mapper(action.payload.resp),
      loadingCount: state.loadingCount - 1,
    }),
    failure: (state, action) => ({
      ...state,
      error: action.payload.error,
      loadingCount: state.loadingCount - 1,
    }),
  };
};
const fetchCategory = httpReducer(
  fetchCategoryActionName,
  initialState.categoryShows,
  categoryReducers()
);
const fetchDirectoryCategory = httpReducer(
  fetchDirectoryCategoryActionName,
  initialState.categoryShows,
  categoryReducers(directoryShowMapper)
);

const searchReducers = (mapper = identity) => ({
  started: (state, action) => ({ ...state, latestRequestID: action.requestID }),
  success: (state, action) => {
    if (action.requestID !== state.latestRequestID) return state;
    return {
      ...state,
      results: mapper(action.payload.resp),
    };
  },
  failure: (state, action) => ({
    ...state,
    error: action.payload.error,
  }),
});

const searchShows = httpReducer(browseSearchShowActionName, initialState.search, searchReducers());
const searchDirectoryShows = httpReducer(
  browseSearchDirectoryShowActionName,
  initialState.search,
  searchReducers(directoryShowMapper)
);

const clearResults = (state, action) => {
  switch (action.type) {
    case clearShowsActionName:
      return {
        ...state,
        latestRequestID: "",
        results: [],
        searchDirectoryShows: [],
      };
    default:
      return state;
  }
};

const activeAdCategories = httpReducer(getCategoriesActionName, initialState.activeAdCategories, {
  success: (state, action) => ({ categories: action.payload.resp }),
});

export default combineReducers({
  categoryShows: fetchCategory,
  categoryDirectoryShows: fetchDirectoryCategory,
  search: reduceReducers(searchShows, clearResults),
  searchDirectoryShows: reduceReducers(searchDirectoryShows, clearResults),
  activeAdCategories,
});
